export default "https://assets.pclncdn.com/web/next-landing/01bc7bc/_next/static/images/hotel-image-tablet-2x-2fb07fdd625b92250cd50cb79c5ed37f.webp";